// React
import PropTypes from "prop-types";

// @mui material components
import {
  Alert,
  Card,
  CircularProgress,
  Fade,
  Grid,
  Icon,
  InputLabel,
  Modal,
  Tooltip,
} from "@mui/material";

// Custom UI components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "40%", xxl: "30%" },
  overflow: "auto",
};

export default function ModalVencimientoDocumentacion({
  open,
  handleClose,
  fechaVencimiento,
  setFechaVencimiento,
  handleSave,
  loading,
}) {

  useEffect(() => {
    if (open ) {
      const hoy = new Date();
      const fechaMas90 = new Date(hoy.setDate(hoy.getDate() + 90));
      const fechaFormateada = fechaMas90.toISOString().split("T")[0]; // yyyy-mm-dd
      setFechaVencimiento(fechaFormateada);
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox mb={2}>
              <SoftBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                pb={0}
              >
                <SoftBox>
                  <SoftTypography variant="h6">Fecha de vencimiento del documento</SoftTypography>
                </SoftBox>
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
              <SoftBox p={3} pt={0}>
                <Alert severity="warning" sx={{fontSize: "0.8rem"}}>
                  El documento perderá validez a partir de la fecha ingresada
                </Alert>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="fechaVencimiento">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Fecha de vencimiento del archivo - Por defecto 90 días desde hoy
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      label="fechaVencimiento"
                      placeholder="Inserte un comentario"
                      type="date"
                      name="fechaVencimiento"
                      value={fechaVencimiento}
                      onChange={(e) => setFechaVencimiento(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </SoftBox>
            </SoftBox>
            <SoftBox display="flex" justifyContent="end" alignItems="center" p={3} pt={0}>
              <SoftBox mr={2}>
                <SoftButton color="primary" circular onClick={handleClose}>
                  <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                  &nbsp;Cancelar
                </SoftButton>
              </SoftBox>
              <SoftBox>
                <SoftButton
                  color="uproGreen"
                  circular
                  onClick={handleSave}
                  disabled={!fechaVencimiento || fechaVencimiento === "" || loading}
                >
                  {loading ? (
                    <CircularProgress size={15} color="white" />
                  ) : (
                    <Icon sx={{ fontWeight: "light" }}>save</Icon>
                  )}
                  &nbsp;Guardar
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalVencimientoDocumentacion.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setDevolucion: PropTypes.func,
  fechaVencimiento: PropTypes.string,
  setFechaVencimiento: PropTypes.func,
  handleSave: PropTypes.func,
  loading: PropTypes.bool,
};
